import { render } from "./Driver.vue?vue&type=template&id=2d66e640&scoped=true"
import script from "./Driver.vue?vue&type=script&lang=js"
export * from "./Driver.vue?vue&type=script&lang=js"

import "./Driver.vue?vue&type=style&index=0&id=2d66e640&scoped=true&lang=css"

import exportComponent from "C:\\Users\\McCoy\\Desktop\\Coding\\Work\\caby_landing_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d66e640"]])

export default __exports__